import classnames from 'classnames/bind'
import React from 'react'
import { useTranslate } from 'react-polyglot'
import { GlobalThemeColors } from '~/@types/colors'
import { GlobalGridPreset } from '~/@types/grid-preset'
import { GlobalTextPreset } from '~/@types/text-preset'
import { GlobalTextStyling } from '~/@types/text-styling'

import ProductCard from '~/components/UI/ProductCard'
import { SearchContentProps } from '~/components/UI/SearchContent'

import { useStyle } from '~/providers/StyleProvider'

import { SEARCH } from '~/data/dictionary'

import css from './styles.module.scss'
import { CARD_PRODUCT_LAYOUT } from '~/components/UI/ProductCard/types'

const cx = classnames.bind(css)

export type SearchRecommendedProductsProps = {
  className?: string
  hasNoResults?: boolean
  upsales?: SearchContentProps['upsales']
}

function SearchRecommendedProducts({
  className,
  hasNoResults,
  upsales,
}: SearchRecommendedProductsProps) {
  const t = useTranslate()
  const gridStyle = useStyle({ grid: GlobalGridPreset.BASE_GRID })
  const titleStyle = useStyle({
    textPreset: GlobalTextPreset.Label12Grotesk,
    textStyling: GlobalTextStyling.UpperCase,
    color: GlobalThemeColors.Black,
  })
  const noResultStyle = useStyle({
    textPreset: GlobalTextPreset.Label24Grotesk,
    textStyling: GlobalTextStyling.UpperCase,
    color: GlobalThemeColors.Black,
  })

  return upsales && upsales?.length > 0 ? (
    <div className={cx(css.SearchRecommendedProducts, className)}>
      <div className={cx(gridStyle, css.gridTop)}>
        <p className={cx(css.title, titleStyle)}>{t(SEARCH.MOST_POPULAR)}</p>
        {hasNoResults && (
          <p className={cx(css.noResults, noResultStyle)}>
            {t(SEARCH.EMPTY_RESULTS)}
          </p>
        )}
      </div>

      <div className={cx(gridStyle, css.gridBody)}>
        {upsales?.map((product, index) => (
          <ProductCard
            className={css.item}
            key={`upsale_${index}`}
            layout={CARD_PRODUCT_LAYOUT.SEARCH_GRID}
            {...product}
          />
        ))}
      </div>
    </div>
  ) : null
}

SearchRecommendedProducts.defaultProps = {}

export default SearchRecommendedProducts
